import { render, staticRenderFns } from "./KanbanView.vue?vue&type=template&id=c0bce23e&scoped=true&"
import script from "./KanbanView.vue?vue&type=script&lang=js&"
export * from "./KanbanView.vue?vue&type=script&lang=js&"
import style0 from "./KanbanView.vue?vue&type=style&index=0&id=c0bce23e&prod&lang=css&"
import style1 from "./KanbanView.vue?vue&type=style&index=1&id=c0bce23e&prod&lang=css&"
import style2 from "./KanbanView.vue?vue&type=style&index=2&id=c0bce23e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bce23e",
  null
  
)

export default component.exports